(function dynamicTextDirectiveDefinition() {
    'use strict';

    angular.module('CustomControlCombo', [])
        .directive('dynamicCombo', ['adminMetadataService', 'errorsExtend',
            function (adminMetadataService, errors) {
                return {
                    replace: true,
                    restrict: 'E',
                    templateUrl: '/app/directives/custom-control-combo/custom-control-combo-template.html',
                    controller: [
                        '$scope', function ($scope) {
                            $scope.value = '';

                            if ($scope.data && $scope.data.metadataOptions && (typeof $scope.data.metadataOptions === 'string')) {
                                $scope.data.metadataOptions = $.parseJSON($scope.data.metadataOptions);
                            }

                            $scope.save = function () {
                                if (this.$parent.value) {
                                    var item = {
                                        metadataId: this.$parent.data.metadataId,
                                        key: this.$parent.value
                                    };
                                    adminMetadataService.addMetadataValues(item).then(function (result) {
                                        $scope.addToOptions(result);
                                    }, function (error) {
                                        errors.showError(error);
                                    });
                                }
                                else {
                                    errors.showError('VerifyFormData');
                                }
                            };

                            $scope.cancel = function () {
                                this.value = '';
                            };

                            $scope.addToOptions = function (result) {
                                this.data.metadataOptions.push({ value: result.key });
                                this.value = '';
                                $('#addItemModal' + this.data.metadataId).modal('hide');
                            };
                        }]
                };
            }]);

    angular.module('CustomControlCombo')
        .directive('dynamicFilterCombo', ['$translate', function () {
            return {
                templateUrl: '/app/directives/custom-control-combo/custom-control-filter-combo-template.html',
                replace: true,
                restrict: 'E',
                controller: [
                    '$scope', function ($scope) {
                        if ($scope.data && !$scope.data.metadataSearchTypeFrom) {
                            $scope.data.metadataSearchTypeFrom = 'Equal';
                        }

                        if ($scope.data && $scope.data.metadataOptions && (typeof $scope.data.metadataOptions === 'string')) {
                            $scope.data.metadataOptions = $.parseJSON($scope.data.metadataOptions);
                        }

                    }
                ],
                link: function (scope, iElement, iAttrs, formCtrl) {
                    scope.filterNullValue = iAttrs.filternullvalue;
                }
            };
        }]);
})();